import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

export const isTailoredOnboardingM2ExperimentFlagEnabled = () => {
	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [expConfig] = UNSAFE_noExposureExp('jira_tailored_onboarding_jtbd');
	return expConfig.get('isEnabled', false);
};
